import { ArrowForwardIcon } from '@chakra-ui/icons';
import { Button, Heading, VStack, Text, Stack } from '@chakra-ui/react';
import React from 'react';
import { AppRoutes } from 'Routes/AppRoutes';
import useLocalizedNavigate from 'Utils/useLocalizedNavigate';

interface ICTAProps{
	shouldIgnoreParentPadding: boolean;
	isBusiness:boolean;
	ctaSubText?: string;
	ctaText?: string;
	isCTA?: boolean;
}

export const CTA = ({shouldIgnoreParentPadding, isBusiness, ctaSubText, ctaText, isCTA}:ICTAProps) => {
	const navigate = useLocalizedNavigate();
	return(
		<VStack 
			align={['flex-start','center']} 
			justifyContent={['center']} 
			bg={['darkCoral']} 
			w={'full'} 
			minH={['800px', '400px']} 
			{...(shouldIgnoreParentPadding && { px: { base: '30px', xl: '80px', '2xl': '192px' } })}
		>
			<Stack spacing={'20px'}  direction={['column', null, null, 'row']} w={'full'} justifyContent={['space-between',null, null, null, null,'space-between']} alignItems={['flex-start', null, null,'center']}>
				<Stack>
					<Heading textTransform={'uppercase'} mb={['20px', null]} fontSize={['40px','48px']}  fontWeight={'bold'} textColor={['white']} w={['auto','700px']}>{ctaText} </Heading>
					<Text fontSize={'18px'} color={['#ECEFF2']}>{ctaSubText} </Text>
				</Stack>
				<Button onClick={() => navigate( isBusiness ? AppRoutes.contact : AppRoutes.LoopForBusiness)} bg={'white'} border={'none'} color={'darkCoral'} variant={'primary'} w={'auto'} h={['50px','60px']}>
					{isBusiness ? 'Schedule a Call' : 'Loop for Business'}
					<ArrowForwardIcon ml={2} boxSize={['5',5]} />
				</Button>
			</Stack>
		</VStack>
	);
};